import React from "react";
import { Box, Button, Popover, SpaceBetween } from "@cloudscape-design/components";
import {
    DEPENDENCY_COVERAGE_HEADER,
    DEPENDENCY_COVERAGE_MESSAGE,
} from "src/web/constants";

export interface MajorVersionUpgradePopoverProps {
    dependencyName: string;
    version: string;
    recommendedVersion: string;
}

export const MajorVersionUpgradePopover: React.FC<MajorVersionUpgradePopoverProps> = ({
    dependencyName,
    version,
    recommendedVersion,
}) => (
    <Popover
        header="Major version upgrade"
        size="medium"
        triggerType="custom"
        content={
            <SpaceBetween size="xs">
                <Box>
                    Upgrading <b>{dependencyName}</b> from <b>{version}</b>{" "}
                    to <b>{recommendedVersion}</b> crosses a major version boundary.
                </Box>
                <Box>
                    Dependency Sentinel currently only automates minor version
                    upgrades. No code review will be raised for this dependency. A
                    manual upgrade is required.
                </Box>
                <Box>Support for major version upgrades is coming soon.</Box>
            </SpaceBetween>
        }
    >
        <Button
            variant="inline-link"
            iconName="status-warning"
            ariaLabel={`Upgrading ${dependencyName} from ${version} to ${recommendedVersion} is a major version upgrade, which is not supported yet`}
        />
    </Popover>
);

export const RiskLevelsInfoPopover: React.FC = () => (
    <Popover
        header="Risk Levels"
        content={
            <Box>
                <p>
                    <b>HIGH_RISK</b>: Current version has negative guidance and no upgrade
                    is available.
                </p>
                <p>
                    <b>AT_RISK</b>: Current version has negative guidance but an upgrade
                    is available.
                </p>
                <p>
                    <b>UPGRADE_AVAILABLE</b>: Current version is fine but a newer
                    recommended version exists.
                </p>
                <p>
                    <b>NO_ACTION_REQUIRED</b>: Current version is fine with no upgrade
                    needed.
                </p>
            </Box>
        }
        triggerType="custom"
    >
        <Button variant="inline-link" iconName="status-info" />
    </Popover>
);

export const DependencyCoverageInfoPopover: React.FC = () => (
    <Popover
        header={DEPENDENCY_COVERAGE_HEADER}
        size="medium"
        triggerType="custom"
        content={<Box>{DEPENDENCY_COVERAGE_MESSAGE}</Box>}
    >
        <Button
            variant="inline-link"
            iconName="status-info"
            ariaLabel="Which dependencies Dependency Sentinel covers"
        />
    </Popover>
);
